import { SfpInstance } from '../http'
import { createSfpApi } from '../../sfp/api'

export default createSfpApi(SfpInstance)



// WEBPACK FOOTER //
// ./src/repository/api/sfp.js